import script from "./StarPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./StarPicker.vue?vue&type=script&setup=true&lang=js"

import "./StarPicker.vue?vue&type=style&index=0&id=6ed49e7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed49e7b"]])

export default __exports__